import { ref } from "vue";
import * as R from "ramda";

const statusHandler = () => {
  const status = ref({});

  const hasState = (key) => {
    return Boolean(status[key]);
  };

  const addState = (key) => {
    const statusValueClone = R.clone(status.value);
    statusValueClone[key] = true;
    status.value = statusValueClone;
  };

  const removeState = (key) => {
    const statusValueClone = R.clone(status.value);
    delete statusValueClone[key];
    status.value = statusValueClone;
  };

  return {
    status,
    hasState,
    addState,
    removeState,
  };
};

export default statusHandler;
